import './SyncView.scss';
import { coreActions } from '@sonar-software/sonar-core';
import { LoadingArovy } from '@ui/general';
import { useNavigate } from 'react-router-dom';
import { GatewayCard, GatewayContent } from '../../general';
import { ImportStatus, ONBOARDING_SYNC_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useEffect } from 'react';
import { useAction, useOnboardingProgress, useSalesforceSync } from '@hooks';
export const SyncView = ({ children, pre, title }) => {
    var _a, _b;
    const navigate = useNavigate();
    const { status, resetSync } = useSalesforceSync(true);
    const { updateProgress } = useOnboardingProgress();
    const refreshOrgs = useAction(coreActions.requestGetCoreOrganizationsAll);
    useEffect(() => {
        if ((status === null || status === void 0 ? void 0 : status.status) === ImportStatus.Completed) {
            refreshOrgs();
            resetSync();
            updateProgress({
                currentlyRunningSfdcImportId: undefined,
                isSalesforceSynced: true,
                latestSuccessfulSfdcImportId: status.id
            });
            navigate('/', { replace: true });
        }
    }, [navigate, refreshOrgs, resetSync, status === null || status === void 0 ? void 0 : status.id, status === null || status === void 0 ? void 0 : status.status, updateProgress]);
    return (React.createElement(GatewayContent, null,
        React.createElement(GatewayCard, { className: 'sync-view', pre: pre, title: title },
            children,
            React.createElement(LoadingArovy, null),
            React.createElement("p", { className: 'sync-status' }, (_b = (_a = status === null || status === void 0 ? void 0 : status.logs[0]) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : ONBOARDING_SYNC_COPY.CONNECTING_FIRST_TIME),
            React.createElement("div", { className: 'sub-info' }, ONBOARDING_SYNC_COPY.CLOSE_THIS_TAB))));
};
